import styled from 'styled-components'

const WrapFilterStores = styled.div`
    position: relative;
`;

export {
    WrapFilterStores
}